import { ExpirableStorage } from './expirable-storage.abstract';
import * as i0 from "@angular/core";
export class ExpirableSessionStorageService extends ExpirableStorage {
    constructor() {
        super();
        this.storageType = 'session';
    }
}
ExpirableSessionStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExpirableSessionStorageService_Factory() { return new ExpirableSessionStorageService(); }, token: ExpirableSessionStorageService, providedIn: "root" });
